import * as Yup from 'yup';

export const addUserSchema = Yup.object().shape({
  name: Yup.string()
    .min(3)
    .max(25)
    .matches(/^[^0-9]+$/, 'Name should not contain numbers')
    .matches(/^(?=.*[^\s])[\w\s]+$/, 'Invalid name')
    .required('Name is required'),
  password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      'Password must be between 8-30 characters with uppercase, lowercase, numbers and symbols.'
    )
    .required('Password is required'),
  confirmpassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Please confirm your password'),
});

export const InviteUserModalSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  role: Yup.string()
    .required('Role is required')
});

export const NewInstallationSchema = Yup.object().shape({
  job_number: Yup.string()
    .required('Job Number is required'),
  // .matches(/^[A-Za-z0-9]+$/, 'Job Number must contain only alphanumeric characters'),

  invoice_number: Yup.string()
    .required('Invoice Number is required'),
  // .matches(/^[A-Za-z0-9]+$/, 'Invoice Number must contain only alphanumeric characters'),

  site_supervisor: Yup.string()
    .required('Site Supervisor is required'),
  // .matches(/^[A-Za-z\s]+$/, 'Site Supervisor must contain only letters and spaces'),

  date: Yup.string()
    .required('Date is required'),

  on_site: Yup.string()
    .required('Will be on site is required'),

  time_allocated: Yup.string()
    .required('Time Allocated is required'),

  call_before_arrive: Yup.string()
    .required('Time Allocated is required'),

  special_notes: Yup.string(),
});

export const customerProfileSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Company Name must be at least 3 characters')
    // .matches(/^[^0-9]+$/, 'Company Name should not contain numbers')
    .matches(/^(?=.*[^\s])[\w\s]+$/, 'Invalid Company Name')
    .required('Company Name is required'),

  contactName: Yup.string()
    .min(3, 'Contact Name must be at least 3 characters')
    .max(25, 'Contact Name must not exceed 25 characters')
    .matches(/^[^0-9]+$/, 'Contact Name should not contain numbers')
    .matches(/^(?=.*[^\s])[\w\s]+$/, 'Invalid Contact Name')
    .required('Contact Name is required'),


  surName: Yup.string(),

  email: Yup.string()
    .email('Invalid email address')
    // .matches(
    //   /^[a-z0-9]+((\.|_)[a-z0-9]+)*@[a-z0-9]+\.[a-z]{2,}$/,
    //   'Email address should contain only lowercase letters'
    // )
    .required('Email is required'),

  billing_email: Yup.string(),

  phone_number: Yup.string()
    // .min(10, 'Phone number must be at least 10 characters')
    // .max(10, 'Phone number must not exceed 10 characters')
    .matches(/^[0-9]+$/, 'Phone number should only contain numbers')
    .required('Phone number is required'),

  foreman_number: Yup.string(),

  foreman: Yup.string(),

  office_phone: Yup.string(),

  special_notes: Yup.string(),

  viper_account: Yup.string(),

  interested: Yup.string()
    .required('Interested is required'),

  gate_code: Yup.string(),
  viper_account: Yup.boolean(),
  address: Yup.string()
    .required('Site Address is required'),

  billing_address: Yup.string()
    .required('Company Address is required'),

  estimated_date: Yup.string()
    .required('Installation date is required'),

  loginDetails: Yup.object().shape({
    email: Yup.string(),
    // .email('Invalid email format')
    // .required('Login email is required'),
    password: Yup.string()
    // .min(8, 'Password must be at least 8 characters long')
    // .required('Password is required'),
  }),
});

export const customerProfileEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Company Name must be at least 3 characters')
    .matches(/^[^0-9]+$/, 'Company Name should not contain numbers')
    .matches(/^(?=.*[^\s])[\w\s]+$/, 'Invalid Company Name')
    .required('Company Name is required'),

  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),

  phone_number: Yup.string()
    .min(3, 'Phone number must be at least 3 characters')
    .max(25, 'Phone number must not exceed 25 characters')
    .matches(/^[0-9]+$/, 'Phone number should only contain numbers')
    .required('Phone number is required'),

  address: Yup.string()
    .min(3, 'Address must be at least 3 characters')
    .max(25, 'Address must not exceed 25 characters')
    .required('Address is required'),

  billing_address: Yup.string()
    .min(3, 'Billing Address must be at least 3 characters')
    .max(25, 'Billing Address must not exceed 25 characters')
    .required('Billing Address is required'),

  interested: Yup.string()
    .required('Interest is required'),

  gate_code: Yup.string()
    .required('Gate Code is required')
    .max(20, 'Gate Code must not exceed 20 characters'),

  estimated_date: Yup.string()
});

export const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    // .matches(
    //   /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@/,
    //   'Invalid email address'
    // )
    // .matches(
    //   /((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-z\-0-9]+\.)+[a-z]{2,3}))$/,
    //   'Invalid email address'
    // )
    // .matches(
    //   /^[a-z0-9]+((\.|_)[a-z0-9]+)*@[a-z0-9]+\.[a-z]{2,}$/,
    //   'email address contains only lowercase letters'
    // )
    .required('Email is required'),
  password: Yup.string()
    // .matches(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    //   'Password must be between 8-30 characters with uppercase, lowercase, numbers and symbols.'
    // )
    .required('Password is required'),
});

export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    // .matches(
    //   /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@/,
    //   'Invalid email address'
    // )
    // .matches(
    //   /((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-z\-0-9]+\.)+[a-z]{2,3}))$/,
    //   'Invalid email address'
    // )
    // .matches(
    //   /^[a-z0-9]+((\.|_)[a-z0-9]+)*@[a-z0-9]+\.[a-z]{2,}$/,
    //   'email address contains only lowercase letters'
    // )
    .required('Email is required'),
});

export const ResetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      'Password must be between 8-30 characters with uppercase, lowercase, numbers and symbols.'
    )
    .required('Password is required'),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Please confirm your password'),
});

export const AddUserSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .matches(
      /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@/,
      'Invalid email address'
    )
    .matches(
      /((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-z\-0-9]+\.)+[a-z]{2,3}))$/,
      'Invalid email address'
    )
    .matches(
      /^[a-z0-9]+((\.|_)[a-z0-9]+)*@[a-z0-9]+\.[a-z]{2,}$/,
      'email address contains only lowercase letters'
    )
    .required('Email is required'),
  firstName: Yup.string()
    .min(3)
    .max(25)
    .matches(/^[^0-9]+$/, 'Name should not contain numbers')
    .matches(/^(?=.*[^\s])[\w\s]+$/, 'Invalid name')
    .required('Name is required'),
  lastName: Yup.string()
    .min(3)
    .max(25)
    .matches(/^[^0-9]+$/, 'Last name should not contain numbers')
    .matches(/^(?=.*[^\s])[\w\s]+$/, 'Invalid Last name')
    .required('Last name is required'),
  password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      'Password must be between 8-30 characters with uppercase, lowercase, numbers and symbols.'
    )
    .required('Password is required'),
});

export const memoSchema = Yup.object().shape({
  subject: Yup.string().required('Subject is required'),
  date: Yup.date().required('Date is required'),
  message: Yup.string().required('Message is required').max(150, 'Message must be at most 150 characters'),
  memoNumber: Yup.string().required('Memo number is required'),
  visibility: Yup.string().required('Visibility is required'),
});
